import { auth } from '../lib/firebase';

// In production, this is relative to the domain. In dev, it might need proxying.
// For this architecture, empty string works because React is served by Flask.
const CLOUD_FUNCTION_BASE_URL = ""; 

export const callBackendFunction = async (endpoint, data) => {
    const backendUrl = `${CLOUD_FUNCTION_BASE_URL}/api/v1/${endpoint}`;
    try {
        let token = 'anonymous-token';
        if (auth.currentUser) {
             token = await auth.currentUser.getIdToken();
        }
        
        const response = await fetch(backendUrl, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}` 
            },
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: 'Unknown Backend Error' }));
            throw new Error(errorData.error || response.statusText);
        }
        return await response.json(); 
    } catch (error) {
        console.error("Backend Call Failed:", error);
        throw new Error(error.message);
    }
};